import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import { IAnswerInterest } from "../../../../../../constants/active_learning";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import InterestTable from "../../../../../ActiveLearning/InterestTable";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import { ReactComponent as IconOpen } from "../../../../../../assets/images/ActiveLearning/icon_open.svg";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const currentIssueNo = 1;

  const question1 = useMemo(() => {
    return props.issue?.questions.find(question => question.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(question => question.order_num === 2);
  }, [props.issue?.questions]);

  const initialAnswer: IAnswerInterest = {
    id: "",
    issue_no: NaN,
    question_no: NaN,
    question_id: NaN,
    interest: "",
    reason: "",
    field_ids: [],
  };
  const initialAnswers = Array.from({ length: 3 }, (_, index) => ({
    ...initialAnswer,
    id: index.toString(),
  }));

  return (
    <>
      <div className={styles.issue}>
        <div className={styles.header}>
          <span className={styles.no}>
            WORK{currentIssueNo < 10 ? `0${currentIssueNo}` : currentIssueNo}
          </span>
          <p className={styles.title}>{props.issue?.title}</p>
          <p className={styles.read}>
            いままでの自分を振り返って、自分のやりたいことや興味があること、そしてその理由を考えよう。
            <br />
            次に、自分のやりたいことや興味があることに関連する分野のタグを選択しよう。※分野は各項目3つまで選択できます。
          </p>
          <p className={styles.example}>
            例：車の写真を撮ること。/人に勉強を教えること。/旅行に行くこと。/野球の練習をすること。/絵を描くこと。/デザイナーになること。/スポーツ選手になること。/宇宙飛行士になること。
          </p>
        </div>
        {question1 && <InterestTable isTeacher answers={initialAnswers} />}
        {question2 && (
          <div className={styles.themEntry}>
            <p className={styles.title}>{question2.title}</p>
            <p className={styles.read}>
              自分の［やりたいこと/興味があること］［その理由］を参考に、自分にはどのような特性があるかを考えてタグを選択しよう。
            </p>
            <div className={styles.checkField}>
              <ul className={styles.actionCategoryList}>
                <li className={styles.text}>選択された特性はありません。</li>
              </ul>
            </div>
          </div>
        )}
        <div className={styles.card}>
          <div className={styles.wrapper}>
            <div className={styles.block}>
              <p className={styles.label}>
                <IconLive />
                POINT
              </p>
              <p className={styles.title}>
                いままでの自分を
                <br className={styles.isPc} />
                振り返る
              </p>
            </div>
            <div className={styles.block}>
              <p>
                CORE、GEAR、GLIDEに入力した内容を参考に、自分の興味・関心や特性を見つけよう。
              </p>
              <div className={clsx(styles.buttonWrapper, styles.isPc)}>
                <Button width={"240px"} height={"38px"} fontSize={"14px"}>
                  COREの回答を見る
                  <IconOpen />
                </Button>
                <Button width={"240px"} height={"38px"} fontSize={"14px"}>
                  GEARで行動を振り返る
                  <IconOpen />
                </Button>
                <Button width={"240px"} height={"38px"} fontSize={"14px"}>
                  GLIDEで自己評価を見る
                  <IconOpen />
                </Button>
              </div>
              <div className={clsx(styles.buttonWrapper, styles.isSp)}>
                <Button width={"100%"} height={"58px"} fontSize={"14px"}>
                  COREのワークの回答を見る
                  <IconOpen />
                </Button>
                <Button width={"100%"} height={"58px"} fontSize={"14px"}>
                  GEARで行動を振り返る
                  <IconOpen />
                </Button>
                <Button width={"100%"} height={"58px"} fontSize={"14px"}>
                  GLIDEで自己評価を見る
                  <IconOpen />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Issue1Material;
